<div class="description-container">
  @if (
    (cardData | method: 'showFullDescription') && (cardData | method: 'getRichTextDescription');
    as richTextDescription
  ) {
    <div class="description rich-text" [style.color]="bodyTextColor" [innerHTML]="richTextDescription"></div>
  } @else {
    @if (cardData | method: 'getProductDesc'; as productDesc) {
      <div class="description plain-text" [style.color]="bodyTextColor">
        {{ productDesc }}
      </div>
    }
  }
</div>
